import React from 'react';
import Pagination from '../Pagination';
import './index.scss';

const Table = ({
    columns,
    data,
    onEdit,
    onDelete,
    // Pagination props
    currentPage,
    totalPages,
    onPageChange,
    totalItems,
    itemsPerPage,
    showPagination = false,
    showPaginationInfo = true
}) => {
    return (
        <div className="table-container">
            <div className="table-wrapper">
                <table className="data-table">
                    <thead>
                        <tr>
                            {columns.map((column, index) => (
                                <th key={index}>{column.header}</th>
                            ))}
                            {(onEdit || onDelete) && <th>Actions</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {columns.map((column, colIndex) => (
                                        <td key={colIndex}>
                                            {column.render ? column.render(row) : row[column.accessor]}
                                        </td>
                                    ))}
                                    {(onEdit || onDelete) && (
                                        <td>
                                            <div className="action-buttons">
                                                {onEdit && (
                                                    <button
                                                        className="btn-edit"
                                                        onClick={() => onEdit(row)}
                                                    >
                                                        Edit
                                                    </button>
                                                )}

                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length + (onEdit || onDelete ? 1 : 0)} className="no-data">
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {showPagination && (
                <div className="table-pagination">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        showInfo={showPaginationInfo}
                    />
                </div>
            )}
        </div>
    );
};

export default Table;